import alert from '../share/alert';
import constants from '../common/nodejs/constants';
import apiService from '../share/util/api/service';
import handler from '../share/util/apiResultValidator';
import util from '../share/util/utils';
import config from '../share/config';
import errorMapping from '../share/util/api/errorMapping';
import Error from '@/common/nodejs/errors';
import { headerType_none, headerType_vehicle, headerType_result, headerType_menu, headerType_vehicle_to_project, headerType_project_to_vehicle, } from "../constants/uiConfigs";
import { TAP_START, TAP_VERSION_INFO, TAP_USER_INFO, TAP_LANGUAGE, TAP_UNIT, TAP_PERSONAL_DATA, TAP_USER_TERMS, TAP_DIVIDER, TAP_LOG_OUT, TAP_TECH_MANUAL, TAP_TO_PROJECT, TAP_TO_MENU, TAP_REPRO_FILE_DOWNLOAD } from './constants';

/**
 * ポップアップメニューの作成
 * @param {object} self this インスタンス
 */
export function createDropDownItems(self) {
  const returnValue = [];
  self.isVoltage = false;
  self.isCloudConnector = false;

  if (self.headerType === headerType_none) {
    returnValue.push(TAP_LANGUAGE);
    if (self.isShowTapVersionInfo()) {
      returnValue.push(TAP_VERSION_INFO);
    }
    return returnValue;
  }

  self.isCloudConnector = true;
  if (self.headerType === headerType_vehicle) {
    // start画面へ戻るアイテムをpush
    returnValue.push(TAP_START);
    self.isVoltage = true;
  }
  if (self.headerType === headerType_vehicle_to_project) {
    // start画面へ戻るアイテムをpush
    returnValue.push(TAP_START);
    self.isVoltage = true;
  }
  if (self.headerType === headerType_project_to_vehicle) {
    // 実行系⇒プロジェクト画面への遷移済フラグが true 且つ、機能プラン：データ再生が対象の場合、Menu遷移確認ダイアログの表示アイテムをpush
    if (isNotTestModeAndDataPlayback(self) && self.isMovedVehicleToProject) {
      returnValue.push(TAP_TO_MENU);
    }
  }
  if (self.headerType === headerType_result) {
    self.isVoltage = true;
  }
  returnValue.push(TAP_USER_INFO);
  if (self.isShowTapVersionInfo()) {
    returnValue.push(TAP_VERSION_INFO);
  }
  returnValue.push(
    TAP_LANGUAGE,
    TAP_UNIT,
    TAP_PERSONAL_DATA,
    TAP_USER_TERMS,
    TAP_TECH_MANUAL
  );
  if (self.headerType === headerType_menu) {
    // プロジェクトIDが存在且つ、機能プラン：データ再生が対象の場合、プロジェクト詳細遷移確認ダイアログの表示アイテムをpush
    if (isNotTestModeAndDataPlayback(self) && self.vehicleInfo?.vehicle?.project?.id) {
      returnValue.push(TAP_TO_PROJECT);
    }
  }
  if (self.headerType === headerType_vehicle_to_project) {
    // プロジェクトIDが存在且つ、機能プラン：データ再生が対象の場合、プロジェクト詳細遷移確認ダイアログの表示アイテムをpush
    if (isNotTestModeAndDataPlayback(self) && self.vehicleInfo?.vehicle?.project?.id) {
      returnValue.push(TAP_TO_PROJECT);
    }
  }
  // 機能プランにリプロが対象の場合、リプロファイルダウンロードを表示
  if (self.userProperty?.functionAvailability?.repro === true) {
    returnValue.push(TAP_REPRO_FILE_DOWNLOAD);
  }
  if (self.currentProvider === config.SBR_DOMAIN) {
    returnValue.push(TAP_DIVIDER);
  }
  const hostname = window.location.hostname;
  if (hostname && hostname.indexOf('gihon') === -1) {
    // 技本ユーザーはサインアウトメニューを表示しない
    returnValue.push(TAP_LOG_OUT);
  }

  return returnValue;
}

/**
 * トレーニングモードでない且つ、機能プラン：データ再生が利用可の判定
 * @param {object} self this インスタンス
 * @returns boolean 判定結果
 */
function isNotTestModeAndDataPlayback(self) {
  return !self.isTestMode && self.isDataPlayback;
}

/**
 * 「プロジェクト参照」プルダウン押下時の確認ダイアログ表示処理
 * @param {object} self this インスタンス
 * @param {string} confirmType 確認ダイアログの区分
 */
export async function showMoveProjectConfirmModal(self, confirmType) {
  try {
    // 確認ダイアログの区分を設定
    self.moveConfirmType = confirmType;
    // 確認ダイアログのメッセージ設定
    self.moveConfirmTitle = self.$t('message.menu_vehicle_to_project');
    self.moveConfirmMessage = self.$t('message.label_confirm_message_move_vehicle_to_project');
    // 確認ダイアログを表示
    self.showModalMoveConfirm = true;

    // ミラーサイトの判定
    self.selectedDataSource = process.env.VUE_APP_BACKUP_TYPE ? constants.MAINTENANCE_ACTIVE_ENV_MIRROR : constants.MAINTENANCE_ACTIVE_ENV_DEFAULT;
    // 遷移用プロジェクト情報の取得
    const params = {
      project_id: self.vehicleInfo.vehicle.project.id,
      region_info: self.selectedDataSource,
    };
    // プロジェクト情報取得API実行
    self.modalLoading = true;
    const response = await apiService.getParamCall(apiService.DIAG, '/projects', params);
    self.modalLoading = false;
    // APIレスポンスの検証
    handler.validate(handler.validateTypes.all, response, self, null, () => {
      // プロジェクト情報の取得
      if (response.data.projects) {
        self.projectsBuff = [];
        for (const projects of response.data.projects) {
          // 5 桁未満のプロジェクト ID は先頭をゼロ埋め
          projects.measuredId = projects.registered_at;
          // UNIX => YYYYMMDD HH:MM 変換
          projects.registered_at = util.timeConverter(projects.registered_at, null, 'min');
          projects.model_type = projects.model_year || projects.classification;
          self.projectsBuff.push(projects);
        }
      }
    }, (result) => {
      // API レスポンスが異常だった場合
      if (result.behaviorType === handler.behaviorTypes.logout) self.logout(self);
    });

  } finally {
    self.modalLoading = false;
  }
}

/**
 * 「Menuへ」プルダウン押下時の確認ダイアログ表示処理
 * @param {object} self this インスタンス
 * @param {string} confirmType 確認ダイアログの区分
 */
export async function showMoveMenuConfirmModal(self, confirmType) {
  // 確認ダイアログの区分を設定
  self.moveConfirmType = confirmType;
  // 確認ダイアログのメッセージ設定
  self.moveConfirmTitle = self.$t('message.menu_project_to_vehicle');
  self.moveConfirmMessage = self.$t('message.label_confirm_message_move_project_to_vehicle');
  // 確認ダイアログを表示
  self.showModalMoveConfirm = true;
}

/**
 * ユーザー情報ダイアログ表示処理
 * @param {object} self this インスタンス
 */
export async function showUserInfoModal(self) {
  // ユーザー情報のダイアログを表示する。
  // 情報の初期化
  self.userInfo = {};
  self.showModalUser = true;
  self.modalLoading = true;
  const response = await apiService.getCall(apiService.ADMIN, '/users/' + self.userProperty.userId);
  self.modalLoading = false;
  handler.validate(
    handler.validateTypes.all,
    response, self, null,
    () => {
      self.userInfo = response.data;
      self.userInfo.previous_login = util.timeConverter(self.userInfo.previous_login);
      self.userInfo.password_expired_time = util.timeConverter(self.userInfo.password_expired_time, null, 'day');
    },
    (result) => {
      self.showModalUser = false;
      if (result.behaviorType === handler.behaviorTypes.logout) {
        self.logout(self);
      } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
        self.resetSession(self);
      }
    }
  );
}

/**
 * 「プロジェクト詳細へ」,「Menuへ」確認ダイアログOKボタン押下処理
 * @param {object} self this インスタンス
 */
export function clickedMoveConfirm(self) {
  if (self.moveConfirmType === TAP_TO_PROJECT.type) {
    // 遷移に必要なプロジェクト情報を設定
    self.cacheDiagProjectList({ list: self.projectsBuff });
    self.cacheProjectDetails({ information: self.projectsBuff[0] });
    self.cacheProjectDataSource(self.selectedDataSource);
    // 実行系⇒プロジェクト画面への遷移済フラグを true に設定
    self.cacheIsMovedVehicleToProject(true);
    // プロジェクト詳細へ遷移
    self.$router.push({ name: 'diagProjectDetails' });
  } else {
    // 実行系⇒プロジェクト画面への遷移済フラグを false に設定
    self.cacheIsMovedVehicleToProject(false);
    // Menuへ遷移
    self.$router.push({ name: 'menu' });
  }
  // ダイアログ閉じ
  self.showModalMoveConfirm = false;
}

/**
 * 「リプロファイルダウンロード」押下処理
 * @param {object} self this インスタンス
 */
export async function reproDataDownload(self) {
  try {
    if (self.modalLoading) return;
    self.reproDataItems = [];
    self.reproDataBaseList = [];
    self.translationLangs = [];
    self.showReproFileDownloadModal = true;
    self.modalLoading = true;
    const invalidReproListErrorCode = Error.ZIP_FILE_NOT_EXIT_DOWNLOAD_FILE;
    const endPoint = "/ccuDownloadUrlList";
    const response = await apiService.getCall(apiService.REPRO, endPoint);
    handler.validate(
      handler.validateTypes.all,
      response, self, null,
      () => {
        // 処理が成功したときのコールバック処理
        if (Array.isArray(response.data)) {
          // ベースデータを作成し、表示時に言語ごとの翻訳を解決する。
          const unitOptionsMap = new Map((self.unitOptions || []).map(unit => [unit.id, unit]));
          self.reproDataBaseList = response.data.map(item => buildReproDataItemBase(item, self.language, unitOptionsMap));
          self.translationLangs = resolveReproTranslationLangs(self, self.reproDataBaseList);
          // リストの先頭のデフォルト翻訳languageをデフォルト表示に設定する。
          if (self.reproDataBaseList.length) {
            self.defaultLang = resolveDefaultLanguage(self.reproDataBaseList[0]);
          } else {
            self.defaultLang = "ja";
          }
          self.reproFileSelectedLanguage = self.defaultLang;
          self.reproDataItems = resolveReproDataItemsByLanguage(self.reproDataBaseList, self.reproFileSelectedLanguage);
          self.reproDataItemsLanguageCache = { language: self.reproFileSelectedLanguage, items: self.reproDataItems };
          self.reproTotalItemLength = self.reproDataItems.length;
          self.reproCurrentPage = 1;
        } else {
          // データの形式が想定と異なる場合はエラーとする
          alert.showError(self, null, self.$t(errorMapping.getErrorMessageForCode(invalidReproListErrorCode)));
          self.showReproFileDownloadModal = false;
        }
        self.modalLoading = false;
      },
      (result) => {
        // 処理が失敗した際にdialogが表示されていたら閉じる
        self.showReproFileDownloadModal = false;
        self.modalLoading = false;
        if (result.causeType === handler.causeTypes.invalidSessionToken) {
          alert.showWarning(self, null, result.message,
            () => {
              self.logout(self);
            }
          );
        } else {
          alert.showError(self, null, result.message,
            () => {
              if (result.behaviorType === handler.behaviorTypes.logout) {
                self.logout(self);
              } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                self.resetSession(self);
              }
            }
          );
        }
      }, null, false
    );
  } finally {
    self.modalLoading = false;
  }
}

function buildReproDataItemBase(item, language, unitOptionsMap) {
  return {
    ...item,
    unit_name: resolveUnitName(item.unit_id, language, unitOptionsMap),
    released_time: util.timeConverter(item.released_time, null, 'day'),
  };
}

function resolveUnitName(unitId, language, unitOptionsMap) {
  const displayNames = unitOptionsMap.get(unitId)?.display_names || [];
  const currentLangName = (displayNames.find(name => name.language === language)?.name || "").trim();
  return currentLangName || displayNames[0]?.name || "";
}

function resolveDefaultLanguage(item) {
  const translations = item?.translations || [];
  const defaultTranslation = translations.find(status => status.is_default === true) || translations[0];
  return defaultTranslation?.language || "ja";
}

function resolveReproTranslationLangs(self, baseList) {
  const langs = [];
  const seen = new Set();
  const translationMap = new Map((self.masterTranslations || []).map(lang => [lang.id, lang]));
  (baseList || []).forEach(item => {
    (item.translations || []).forEach(translation => {
      const language = translation?.language;
      if (language && !seen.has(language)) {
        seen.add(language);
        const message = translationMap.get(language)?.display?.[self.language];
        langs.push({
          name: language,
          label: message || language,
        });
      }
    });
  });
  return langs;
}

export function resolveReproDataItemsByLanguage(baseList, selectedLanguage) {
  return (baseList || []).map(item => {
    const translations = item.translations || [];
    const resolved =
      translations.find(status => status.language === selectedLanguage)
      || translations.find(status => status.is_default === true)
      || translations[0];
    return {
      ...item,
      translations: resolved,
    };
  });
}

/**
 * 「リプロファイル事前ダウンロード」ダイアログ「ダウンロード」ボタン押下処理
 * @param {object} self this インスタンス
 * @param {object} reproItem 選択対象レコード（リプロファイル項目）
 */
export async function downloadReproFileFunc(self, reproItem) {
  try {
    self.fileUrl = null;
    const reproFileName = ".zip";
    const path = reproItem?.file_path;
    const isZipFile = (path || "").toLowerCase().endsWith(reproFileName);
    if (!isZipFile) {
      alert.showError(self, null, self.$t('message.download_error_message'));
      return;
    }

    self.isAppProcessing = true;
    const endPoint = "/downloadUrl";
    const params = {
      file_path: path
    };
    const response = await apiService.getParamCall(config.REPRO, endPoint, params);
    handler.validate(
      handler.validateTypes.all,
      response, self, null,
      () => {
        // 処理が成功したときのコールバック処理
        self.fileUrl = response.data.fileUrl;
      },
      (result) => {
        // 処理が失敗したときのコールバック処理
        if (result.causeType === handler.causeTypes.invalidSessionToken) {
          alert.showWarning(self, null, result.message,
            () => {
              self.logout(self);
            });
        } else {
          // ダウンロード失敗時のエラーダイアログの文言を統一する
          const message = self.$t('message.download_error_message');
          alert.showError(self, null, message,
            () => {
              if (result.behaviorType === handler.behaviorTypes.logout) {
                self.logout(self);
              } else if (result.behaviorType === handler.behaviorTypes.resetSession) {
                self.resetSession(self);
              }
            });
        }
      }, null, false
    );
  } finally {
    self.isAppProcessing = false;
  }
}

/**
 * リプロファイル表示言語変更処理
 * @param {object} self this インスタンス
 * @param {string} selected 選択対象レコードの言語
 */
export async function updateSelectedLang(self, selected) {
  const previousPage = self.reproCurrentPage;
  const items = self.getReproDataItemsByLanguage(selected);
  self.reproDataItems = items;
  self.reproTotalItemLength = items.length;
  const totalPage = Math.max(1, Math.ceil(self.reproTotalItemLength / self.reproPageSize));
  self.reproCurrentPage = Math.min(previousPage, totalPage);
}
